import { render, staticRenderFns } from "./ivr-activity.vue?vue&type=template&id=23d2b7fd&scoped=true&"
import script from "./ivr-activity.vue?vue&type=script&lang=js&"
export * from "./ivr-activity.vue?vue&type=script&lang=js&"
import style0 from "./ivr-activity.vue?vue&type=style&index=0&id=23d2b7fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2b7fd",
  null
  
)

export default component.exports